import React from 'react';
import Stack from '@mui/material/Stack';
import MultiCardDisplay from './stepComponents/MultiCardDisplay';
import { CardConfigurerStepProps } from '../CardConfigurerForm';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CreateIcon from '@mui/icons-material/Create';
import { getCardFeeByVariant } from 'lib/product';
import { Field } from 'react-final-form';
import { isCardDotGiftCard } from '../configurerFlags';
import PanelLayout from './stepComponents/PanelLayout';

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      '&[hidden]': {
        display: 'none',
      },
    },
    cardSummary: {
      padding: `${theme.spacing(2)} ${theme.spacing(3.5)}`,
      marginTop: theme.spacing(5),
      maxWidth: '626px',
      width: '65%',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        padding: theme.spacing(2),
      },
    },
    item: {
      width: '100%',
      fontSize: '16px',
      lineHeight: '19px',
      paddingBottom: theme.spacing(2),
    },
    editButton: {
      color: 'white',
      fontSize: '16px',
      padding: 0,
      '& .MuiTouchRipple-root': {
        color: 'white',
      },
    },
    label: {
      color: '#8F8F8F',
    },
    buttonWrapper: {
      width: '100%',
      borderTop: '1px solid #8F8F8F',
      paddingTop: theme.spacing(2),
    },
    editIcon: {
      color: 'white',
      marginRight: theme.spacing(1),
    },
    editText: {
      textDecoration: 'underline',
      fontWeight: 400,
    },
  }),
  { name: 'CardConfirm' },
);

const CardConfirm: React.FC<CardConfigurerStepProps> = ({ step, index, product, values, form, onChange, steps, submitButton }) => {
  const classes = useStyles();
  const cardNumber = values.recipients?.length;
  const totalValue = values && values.recipients && values.cardValue && (values.recipients.length * values.cardValue).toFixed(2);
  const selectedVariant = product.variants.filter((item) => item.id === values.variantId);
  const cardFees = cardNumber && (getCardFeeByVariant(selectedVariant[0]) * cardNumber).toFixed(2);

  const editRecipient = () => {
    steps && onChange && onChange(steps.indexOf('Recipient'));
  };

  const title = 'Review Order';

  const cardImageContent = <MultiCardDisplay defaultProductHandle={product.handle} values={values} showLogo={!!values.cardCustomImage && !isCardDotGiftCard(product)} />;

  const formContent = (
    <Stack spacing={2}>
      <Field name="cardConfirm" defaultValue="">
        {() => (
          <div className={classes.cardSummary} style={{ marginTop: '40px' }}>
            <Stack className={classes.item} direction="row" justifyContent="space-between">
              <Typography className={classes.label}>Number of cards</Typography>
              <Typography>{cardNumber}</Typography>
            </Stack>
            <Stack className={classes.item} direction="row" justifyContent="space-between">
              <Typography className={classes.label}>Total Card Value (AUD)</Typography>
              <Typography>${totalValue}</Typography>
            </Stack>
            {!!Number(cardFees) && (
              <Stack className={classes.item} direction="row" justifyContent="space-between">
                <Typography className={classes.label}>Card Fees</Typography>
                <Typography>${cardFees}</Typography>
              </Stack>
            )}
            <Stack className={classes.buttonWrapper} direction="row" justifyContent="flex-end">
              <Button className={classes.editButton} onClick={editRecipient}>
                <CreateIcon className={classes.editIcon} />
                <span className={classes.editText}>Edit</span>
              </Button>
            </Stack>
          </div>
        )}
      </Field>
    </Stack>
  );

  return (
    <div className={classes.root} hidden={step !== index}>
      <PanelLayout value={step} index={index} title={title} cardImageContent={cardImageContent} formContent={formContent} buttonsContent={submitButton} />
    </div>
  );
};

export default CardConfirm;
